import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

export const INVOICE_ITEM_ROOTUI_TYPE = 'INVOICE_ITEM_CONTAINER';

import type { InvoiceItemModalProps } from './types';

export const InvoiceItemUpsertAction = createAction(
  rootUiActions.createDialog.toString(),
  (props: InvoiceItemModalProps) =>
    rootUiTypes.mkRootUiData({
      type: INVOICE_ITEM_ROOTUI_TYPE,
      props: ImmutableMap({
        modalType: props?.modalType || 'drawer',
        formComponentProps: props.formComponentProps,
        context: props?.context,
      }),
    }),
);
